import { ProductHeaderHelper } from './headerHelper/ProductHeaderHelper';
import { RefundHeaderHelper } from './headerHelper/RefundHeaderHelper';
import { TableFormatHelper } from './TableFormatHelper';

export const CsvFormatHelper = {
    baseDateTimePropertyList: ['dateDeleteAt', 'dateCreateAt', 'dateModifyAt'],
    defaultDateTimePropertyList: ['dateCalculationAt'],
    defaultDatePropertyList: ['dateOrderOn', 'datePaymentOn', 'dateRefundOn', 'dateEffectiveOn'],

    getDefaultDateTimePropertyList(): string[] {
        return [...CsvFormatHelper.baseDateTimePropertyList];
    },

    getAllDateTimePropertyList(): string[] {
        return this.removeDuplicateFromList([
            ...RefundHeaderHelper.getDateTimePropertyList(),
            ...ProductHeaderHelper.getDateTimePropertyList()
        ]);
    },

    getAllDatePropertyList(): string[] {
        return this.removeDuplicateFromList([
            ...RefundHeaderHelper.getDatePropertyList(),
            ...ProductHeaderHelper.getDatePropertyList()
        ]);
    },

    removeDuplicateFromList(propertyList: string[]): string[] {
        return propertyList.filter((value, index, self) => self.indexOf(value) === index);
    },

    formatDateTimeCsvValue(value: string, key: string): string {
        // version 1
        // if (CsvFormatHelper.getAllDateTimePropertyList().includes(key)) {
        //     return TableFormatHelper.formatDateTime(value as string);
        // }
        // if (CsvFormatHelper.getAllDatePropertyList().includes(key)) {
        //     return TableFormatHelper.formatDate(value as string);
        // }
        // return value;
        // version 2
        if (this.baseDateTimePropertyList.includes(key)) {
            return TableFormatHelper.formatDateTime(value as string);
        }
        if (this.defaultDatePropertyList.includes(key)) {
            return TableFormatHelper.formatDate(value as string);
        }
        return value;
    }
};
